import React, { Component } from 'react'
import { Avatar, injectTooltip } from 'react-md'

class TooltipAvatar extends Component {
  render () {
    const { children, tooltip, ...rest } = this.props
    return (
      <div className='artwork-icon'>
        {tooltip}
        <Avatar {...rest}>{children}</Avatar>
      </div>
    )
  }
}

const InjectTooltipAvatar = injectTooltip(TooltipAvatar)

const ArtworkThumbnail = ({ src }) => (
  <InjectTooltipAvatar
    tooltipLabel={<img width='80px' src={src} alt='value' />}
    tooltipPosition='left'
    tooltipDelay={150}
    src={src}
    role='presentation'
    iconSized
  />
)

export default ArtworkThumbnail



// WEBPACK FOOTER //
// ./src/containers/Artworks/ArtworkThumbnail.js